import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import practivemanagementService from "services/hrm/practivemanagementService";

export const dSNhanVien = createAsyncThunk(
  "practiveManagementSlice/dSNhanVien",
  async (data, { rejectWithValue }) => {
    try {
      const response = await practivemanagementService.dSNhanVien(data);
      return {
        type: data.type,
        data: response.data?.data,
      };
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const insertKeHoachThucHanh = createAsyncThunk(
  "practiveManagementSlice/insertKeHoachThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response =
        await practivemanagementService.insertKeHoachThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getThongTinNhanVienThucHanh = createAsyncThunk(
  "practiveManagementSlice/getThongTinNhanVienThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response =
        await practivemanagementService.getThongTinNhanVienThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getThongTinNguoiPhuTrach = createAsyncThunk(
  "practiveManagementSlice/getThongTinNguoiPhuTrach",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response =
        await practivemanagementService.getThongTinNguoiPhuTrach(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getThongTinPhieuKeHoachThucHanh = createAsyncThunk(
  "practiveManagementSlice/getThongTinPhieuKeHoachThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response =
        await practivemanagementService.getThongTinPhieuKeHoachThucHanh(id);
      if (onSuccess) onSuccess(response.data);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const insertGiayToKemTheoThucHanh = createAsyncThunk(
  "practiveManagementSlice/insertGiayToKemTheoThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response =
        await practivemanagementService.insertGiayToKemTheoThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDanhSachphieuKeHoachThucHanh = createAsyncThunk(
  "practiveManagementSlice/getDanhSachphieuKeHoachThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await practivemanagementService.getDanhSachphieuKeHoachThucHanh(data);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteFileGIayTokemTheo = createAsyncThunk(
  "practiveManagementSlice/deleteFileGIayTokemTheo",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response =
        await practivemanagementService.deleteFileGIayTokemTheo(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllFileByThucHanhChiTietId = createAsyncThunk(
  "practiveManagementSlice/getAllFileByThucHanhChiTietId",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response =
        await practivemanagementService.getAllFileGiayToKemTheoByThucHanhId(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deletePhieu = createAsyncThunk(
  "practiveManagementSlice/deletePhieu",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await practivemanagementService.deletePhieu(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateKetQuaThucHanh = createAsyncThunk(
  "practiveManagementSlice/updateKetQuaThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response =
        await practivemanagementService.updateKetQuaThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const inPhanCongThucHanh = createAsyncThunk(
  "practiveManagementSlice/inPhanCongThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await practivemanagementService.inPhanCongThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const inDanhGiaThucHanh = createAsyncThunk(
  "practiveManagementSlice/inDanhGiaThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await practivemanagementService.inDanhGiaThucHanh(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const danhSachTiepNhanThucHanhprint = createAsyncThunk(
  "practiveManagementSlice/danhSachTiepNhanThucHanhprint",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response =
        await practivemanagementService.danhSachTiepNhanThucHanhPrint(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateDanhSachTiepNhanThucHanhPrint = createAsyncThunk(
  "practiveManagementSlice/updateDanhSachTiepNhanThucHanhPrint",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await practivemanagementService.updateDanhSachTiepNhanThucHanhPrint(
          data,
        );
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updatDanhGiaThucHanhPrint = createAsyncThunk(
  "practiveManagementSlice/updatDanhGiaThucHanhPrint",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await practivemanagementService.updateDanhGiaThucHanhPrint(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDataHopDongThucHanhprint = createAsyncThunk(
  "practiveManagementSlice/getDataHopDongThucHanhprint",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response =
        await practivemanagementService.getDanhSachTiepNhanThucHanhPrint(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteChiTietTiepNhanThucHanhByID = createAsyncThunk(
  "practiveManagementSlice/deleteChiTietTiepNhanThucHanhById",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      console.log(data, "data");
      const response =
        await practivemanagementService.deleteChiTietTiepNhanThucHanhById(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDataDanhGiaThucHanhById = createAsyncThunk(
  "practiveManagementSlice/getDataDanhGiaThucHanhById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response =
        await practivemanagementService.getDataDanhGiaThucHanhById(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllKhoaPhongKhamTapDoan = createAsyncThunk(
  "practiveManagementSlice/getAllKhoaPhongKhamTapDoan",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await practivemanagementService.getAllKhoaPhongKhamTapDoan();
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllPhongKhamBenhVienTapDoan = createAsyncThunk(
  "practiveManagementSlice/getAllPhongKhamBenhVienTapDoan",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await practivemanagementService.getAllPhongKhamBenhVienTapDoan();
      console.log(response, "response");
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const putHoanThanhThucHanh = createAsyncThunk(
  "practiveManagementSlice/putHoanThanhThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response =
        await practivemanagementService.putHoanThanhThucHanh(data);
      onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const checkHoanThanhThucHanh = createAsyncThunk(
  "practiveManagementSlice/checkHoanThanhThucHanh",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data, "data");
      const { id, onSuccess } = data;
      const response =
        await practivemanagementService.getCheckHoanThanhThucHanh(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDataXacNhanThucHanhPrint = createAsyncThunk(
  "practiveManagementSlice/getDataXacNhanThucHanhPrint",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response =
        await practivemanagementService.getDataXacNhanThucHanhPrint(id);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const uploadHoaDon = createAsyncThunk(
  "practiveManagementSlice/uploadHoaDon",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await practivemanagementService.upLoadHoaDon(data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteHoaDon = createAsyncThunk(
  "practiveManagementSlice/deleteHoaDon",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await practivemanagementService.deleteHoaDonById(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const hoanThienHoSo = createAsyncThunk(
  "practiveManagementSlice/hoanThienHoSo",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, chiTiet } = data;
      const response = await practivemanagementService.hoanThienHoSo(chiTiet);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  danhSachNhanVien: [],
  thongTinNhanVienCanThucHanh: {},
  keHoachThuhanhDetail: {},
  danhSachPhieu: [],
  danhSachFileGiayToKemTheo: [],
  danhSachKhoaPhongKhamTapDoan: [],
  danhSachPhongKhamBenhVien: [],
  listByType: {
    type1: [],
    type2: [],
    type3: [],
    type4: [],
    type5: [],
    type6: [],
  },
};

const practiveManagementSlice = createSlice({
  name: "practiveManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dSNhanVien.pending, (state) => {
        state.loading = true;
      })
      .addCase(dSNhanVien.fulfilled, (state, action) => {
        state.loading = false;
        const { type, data } = action.payload;
        state.listByType[`type${type}`] = data;
        state.danhSachNhanVien = action.payload;
      })
      .addCase(dSNhanVien.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getThongTinNhanVienThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(getThongTinNhanVienThucHanh.fulfilled, (state, action) => {
        state.loading = false;
        state.thongTinNhanVienCanThucHanh = action.payload;
      })
      .addCase(getThongTinNhanVienThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(insertKeHoachThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(insertKeHoachThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(insertKeHoachThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getThongTinNguoiPhuTrach.pending, (state) => {
        state.loading = true;
      })
      .addCase(getThongTinNguoiPhuTrach.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getThongTinNguoiPhuTrach.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getThongTinPhieuKeHoachThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(getThongTinPhieuKeHoachThucHanh.fulfilled, (state, action) => {
        state.loading = false;
        state.keHoachThuhanhDetail = action.payload;
      })
      .addCase(getThongTinPhieuKeHoachThucHanh.rejected, (state) => {
        state.loading = false;
      })
      .addCase(insertGiayToKemTheoThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(insertGiayToKemTheoThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(insertGiayToKemTheoThucHanh.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDanhSachphieuKeHoachThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachphieuKeHoachThucHanh.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachPhieu = action.payload;
      })
      .addCase(getDanhSachphieuKeHoachThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteFileGIayTokemTheo.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFileGIayTokemTheo.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteFileGIayTokemTheo.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAllFileByThucHanhChiTietId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllFileByThucHanhChiTietId.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachFileGiayToKemTheo = action.payload;
      })
      .addCase(getAllFileByThucHanhChiTietId.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deletePhieu.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhieu.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePhieu.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateKetQuaThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateKetQuaThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateKetQuaThucHanh.rejected, (state) => {
        state.loading = false;
      })
      .addCase(inPhanCongThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(inPhanCongThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(inPhanCongThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(danhSachTiepNhanThucHanhprint.pending, (state) => {
        state.loading = true;
      })
      .addCase(danhSachTiepNhanThucHanhprint.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(danhSachTiepNhanThucHanhprint.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateDanhSachTiepNhanThucHanhPrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        updateDanhSachTiepNhanThucHanhPrint.fulfilled,
        (state, action) => {
          state.loading = false;
        },
      )
      .addCase(updateDanhSachTiepNhanThucHanhPrint.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDataHopDongThucHanhprint.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDataHopDongThucHanhprint.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getDataHopDongThucHanhprint.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteChiTietTiepNhanThucHanhByID.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteChiTietTiepNhanThucHanhByID.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteChiTietTiepNhanThucHanhByID.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDataDanhGiaThucHanhById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDataDanhGiaThucHanhById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getDataDanhGiaThucHanhById.rejected, (state) => {
        state.loading = false;
      })
      .addCase(inDanhGiaThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(inDanhGiaThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(inDanhGiaThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updatDanhGiaThucHanhPrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatDanhGiaThucHanhPrint.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatDanhGiaThucHanhPrint.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAllKhoaPhongKhamTapDoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllKhoaPhongKhamTapDoan.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachKhoaPhongKhamTapDoan = action.payload;
      })
      .addCase(getAllKhoaPhongKhamTapDoan.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAllPhongKhamBenhVienTapDoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPhongKhamBenhVienTapDoan.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachPhongKhamBenhVien = action.payload;
      })
      .addCase(getAllPhongKhamBenhVienTapDoan.rejected, (state) => {
        state.loading = false;
      })

      .addCase(putHoanThanhThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(putHoanThanhThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(putHoanThanhThucHanh.rejected, (state) => {
        state.loading = false;
      })
      .addCase(checkHoanThanhThucHanh.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkHoanThanhThucHanh.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(checkHoanThanhThucHanh.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDataXacNhanThucHanhPrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDataXacNhanThucHanhPrint.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getDataXacNhanThucHanhPrint.rejected, (state) => {
        state.loading = false;
      })

      .addCase(uploadHoaDon.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadHoaDon.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadHoaDon.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteHoaDon.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHoaDon.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteHoaDon.rejected, (state) => {
        state.loading = false;
      })

      .addCase(hoanThienHoSo.pending, (state) => {
        state.loading = true;
      })
      .addCase(hoanThienHoSo.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(hoanThienHoSo.rejected, (state) => {
        state.loading = false;
      });
  },
});
// eslint-disable-next-line no-empty-pattern
export const {} = practiveManagementSlice.actions;

export default practiveManagementSlice.reducer;
